import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { CompositeProductsListComponent } from './list/list.component';
import { CompositeProductEditComponent } from './edit/edit.component';
import { CompositeProductModel, HxProductInfoService } from 'hx-services';

const compositeProductResolveFn: ResolveFn<CompositeProductModel> = route => inject(HxProductInfoService).getCompositeProductById(Number(route.paramMap.get('id')));

export const compositeProductsRoutes: Routes = [
  {
    path: '', component: CompositeProductsListComponent,
    data: {
      breadcrumb: 'List'
    }
  },
  {
    path: 'new', component: CompositeProductEditComponent,
    data: {
      breadcrumb: 'Create'
    }
  },
  {
    path: ':id/edit', component: CompositeProductEditComponent,
    resolve: {
      product: compositeProductResolveFn
    },
    data: {
      breadcrumb: 'Edit'
    }
  },
];
